import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { DetailsList, DetailsListLayoutMode } from 'office-ui-fabric-react/lib/DetailsList';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Table } from "react-bootstrap";
import { getProvisioningJobs } from "../components/Requests/Requests";
import { 
    PageLayout,
  StandardScreen,
  StandardSearchBox, 
  StatusMessage
} from '../components/Layout';

class ProvisioningJobs extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            columns:[],
            showTable: false,
            items: [],
            sortAscending: true,
            sortColumnName: true,
            activeItem: null,
            showModal: false,
            isDraggable: false,
            rowItem: {},
            loading: false,
            error:"",
            searchValue: ""
        }
    }

    getProvisioningJobs(guid) {
        if (!guid || guid.trim() === '') {
            this.setState({ error: "Please enter a GUID to search", loading: false });
            return;
        }
        
        this.setState({loading:true,error:"", showTable: false});
        getProvisioningJobs(this.props.accessToken, guid).then((response) => {
              if (response.status === 200) {
                  response.json().then((data) => {
                      if(data.length)
                          this.createHeadersAndRows(data);
                      else
                          this.showErrorMessage(204);
                  });
                } else {
                  this.showErrorMessage(response.status);
              }
          }).catch((error) => {
              console.error('Error fetching provisioning jobs:', error);
              this.setState({ error: "An error occurred while fetching data", loading: false });
          });
      }

  createHeadersAndRows = (data) =>{
      let columns = [];
        Object.keys(data[0]).forEach(key => {
          columns.push({
              key: key,
              name: key,
              fieldName: key,
              minWidth: 100,
              maxWidth: 100,
              isSorted:  key === 'date' ? true : false,//can make this property mutable for specific columns, so that the arrow isn't shown om every column
              isSortedDescending: true, //this is for negating the current form of ordering.
              isResizable: true,
              data: 'string',//was number
              value: 'No Results',
              compact: true,
              onColumnClick: this.onColumnClick,//calls the method that handles the column clicks
              onRender: this._renderCellColumn.bind(this)
          });  
      }); 
      this.setState({columns:columns,items:data,showTable:true,loading:false,error:""})
    }

  _renderCellColumn(row, something_we_do_not_understand, column){ 
      for (const [key, value] of Object.entries(row)) {
          if(column.key === key){
              return <span>{value}</span>
          }   
      }
    }

    onColumnClick = () => {
        //alert('column clicked');
    }

   onRowClick = (item, index, ev) => { 
      this.setState({showModal:true, rowItem:item})
    }
    
    createLegend(json) {
      let legend = [];
      for (let i = 0; i < json["names"].length; i++) {
        let type = "fa fa-circle text-" + json["types"][i];
        legend.push(<i className={type} key={i} />);
        legend.push(" ");
        legend.push(json["names"][i]);
      }
      return legend;
    }
  render() {
      return (
          <PageLayout>
              <StandardScreen
                  title="Provisioning Logs"
                  description={
                      <span>
                          This table will display any items relating to the GUID supplied in the search bar.
                          <span style={{ fontWeight: 900 }}> Double click on row to view details.</span>
                      </span>
                  }
                  loading={this.state.loading}
              >
                  <StandardSearchBox
                      label="GUID"
                      placeholder="Enter GUID to search..."
                      value={this.state.searchValue}
                      onChange={newValue => this.setState({
                          searchValue: newValue,
                          error: "",
                          showTable: false
                      })}
                      onSearch={newValue => this.getProvisioningJobs(newValue)}
                  />

                  {this.state.error && (
                      <StatusMessage type="error">
                          {this.state.error}
                      </StatusMessage>
                  )}

                  {!this.state.showTable && !this.state.loading && !this.state.error && (
                      <div style={{
                          textAlign: 'center',
                          padding: '40px',
                          color: '#666'
                      }}>
                          <Icon iconName="BranchSearch" style={{ fontSize: '48px', marginBottom: '16px' }} />
                          <div>Enter a GUID above to search for provisioning logs</div>
                      </div>
                  )}

                  {this.state.showTable && (
                      <div style={{ marginTop: '20px' }}>
                          <Table striped hover>
                              {this.updateTable()}
                          </Table>
                      </div>
                  )}

                  {this.state.showModal && this.renderModal()}
              </StandardScreen>
          </PageLayout>
      );
    }

  updateTable = () =>{
        return (
          <div className="listContainer">   
              <div className="" data-is-scrollable="true">
              <DetailsList onItemInvoked={this.onRowClick} layoutMode={DetailsListLayoutMode.fixedColumns} onActiveItemChanged={this.onColumnClick} onColumnHeaderClick={this.onColumnClick} items={this.state.items} columns={this.state.columns} ></DetailsList>
              </div>
          </div>
        )
    }

  renderModal = () =>{
      return (
          <div>
            <Modal isOpen={this.state.showModal} onDismiss={this._closeModal} isBlocking={false} containerClassName={"container1"}>
              <div className={"card-header header1"}>
                <span className="ms-font-l">Provisioning Log Details</span>
              </div>
              <div className={"body"}>
                <DefaultButton onClick={this._closeModal} text="Close" />       
                <div style={{ marginTop: '16px' }}>
                  {this.renderModalContents()}
                </div>  
              </div>
            </Modal>
          </div>
        );
    }

  renderModalContents = () =>{
      let items = [];
      for (const [key, value] of Object.entries(this.state.rowItem)) {
          items.push(
              <div key={key} style={{ marginBottom: '8px' }}>
                  <span className="ms-font-m">
                      <strong>{key}:</strong> {value ? value.toString() : 'N/A'}
                  </span>
              </div>
          );
      }
      return items;
    }

    _closeModal = () => {
      this.setState({ showModal: false });
    };

  showErrorMessage = (status) =>{
      let errorMessage = "";
      switch (status) {
          case 204:
              errorMessage = "No content found for the provided GUID";
              break;
          case 404:
              errorMessage = "No resources found for the provided GUID";
              break;
          case 500:
              errorMessage = "Internal Server Error - please try again later";
              break;
          default:
              errorMessage = "An unexpected error occurred";
      }
      this.setState({error: errorMessage, loading: false, showTable: false});
    }
}

export default ProvisioningJobs;